<template>
<div>
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light">
          <img src="/logo.png" width="60" height="40" class="d-inline-block align-top img-f" alt="logo" loading="lazy">
      </nav>
     </div>

     <div class="row justify-content-center">
       <div class="col-sm-12 col-lg-6">
         <img src="/404-2.jpg" alt="404" class="img-fluid" />
       </div>
     </div>

     <div class="container">
       <h3 class="text-center" style="color: #033953">SORRY, PAGE NOT FOUND! </h3>
       <p class="text-center">The page you are looking for might have been removed, had its name changed or is temporarily unavailable</p>
       <div class="text-center">
           <router-link to="/" class="btn btn-back" style="text-decoration: none; color: white;">Go Back</router-link>
       </div>
     </div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.btn-back {
  background: #48c074;
  border-radius: 38.5px;
  color: #fff;
  padding: 10px 25px;
  transition: all 0.5s;
}

</style> 